import Header from '@/components/Header';
import AcquisitionBanner from '@/components/AcquisitionBanner';
import Hero from '@/components/Hero';
import About from '@/components/About';
import Leadership from '@/components/Leadership';
import ActivitiesCarousel from '@/components/ActivitiesCarousel';
import Quality from '@/components/Quality';
import Careers from '@/components/Careers';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <AcquisitionBanner />
      <main>
        <Hero />
        <About />
        <Leadership />
        <ActivitiesCarousel />
        <Quality />
        <Careers />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
